import { Text } from "../../components/Text";
import {ReactComponent as UserIcon} from "../../svg/Usericon.svg"
import { useForm, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import {InputTextarea } from "primereact/inputtextarea";
import { CustomButton } from "../../components/CustomButton";
import { classNames } from "primereact/utils";
import { Dropdown } from "primereact/dropdown";
import { useDispatch, useSelector } from "react-redux";
import * as Messag from '../../config/ToastMessage';
import QRCode from "react-qr-code";
import { useEffect, useState,useRef } from "react";
import { Toast } from "primereact/toast";
import { subscription } from "../../reducers/authSlice";

import './index.css';

import {
  getCompany, 
  setCompany,
  updateCompany
} from "../../reducers/companySlice";

function UserProfile() {

   const toast = useRef(null);

    const {user,userSub} = useSelector((state) => state.authenticate);
    const dispatch = useDispatch();
  
   const {company} = useSelector((state) => state.company);

 useEffect(()=>{

  if (user.companyId) {
    dispatch(subscription(user.companyId)).then((data)=>{
    })
  }

  dispatch(getCompany(user.companyId))
  .unwrap()
  .then((data)=>{
      if (data.company) {    
        dispatch(setCompany(data.company))
      }     
  })

 },[])

 useEffect(()=>{
  if (company) {
    reset({
      businessMobno: company.phone,
      personalMobno:company.personalPhone,
      gst: company.gstNumber,
      pan:company.panNumber,
      billadd:company.billingAddress,
    }) 
  }
 },[company])

      const defaultValues = {
        businessMobno: "",
        personalMobno: "",
        gst: "",
        pan:"",
        billadd:"",
      };



      const [mode,setmode]=useState(false);
      const {
        control,
        formState: { errors },
        handleSubmit,
        reset,
        setValue,
      } = useForm({ defaultValues });



      const handelmode=()=>{
        setmode(!mode)
      }
      //function form get error message
      const getFormErrorMessage = (name) => {
        if(mode)
        return (
          errors[name] && <small className="p-error">{errors[name].message}</small>
        );
        return (<></>);
      };

    
  const onSubmit = async data => { 
      if (!mode) {
        const updatedData = {
          billingAddress:data.billadd,
          phone:data.businessMobno,
          personalPhone:data.personalMobno,
          gstNumber:data.gst,
          panNumber:data.pan,
        }
        dispatch(updateCompany({companyId:user.companyId,updatedData}))
        .unwrap()
        .then((data)=>{
            if(data.response[0]){
              toast.current.show({ severity: 'success', detail: 'User data updated successful'});
             
              return;
            }
        })
      }

    };
  
    const handelQR = () => {
      
      // //get svg element.
      var svg = document.getElementById("generatedQrCode");

      // //get svg source.
      var serializer = new XMLSerializer();
      var source = serializer.serializeToString(svg);

      // //convert svg source to URI data scheme.
      var url = "data:image/svg+xml;charset=utf-8,"+encodeURIComponent(source);

      const qrCodeURL = document.getElementById('generatedQrCode')
      let aEl = document.createElement("a");
      aEl.href = url;
      aEl.download = "QR_Code.svg";
      document.body.appendChild(aEl);
      aEl.click();
      document.body.removeChild(aEl);
    }
    return ( <>
      <div>
            <Toast ref={toast} />
            <div className={`w-11 m-auto py-3 `} >
                <Text type={'heading'}>UserProfile</Text>
            <div className='flex align-content-center panel-border py-2' >
                <UserIcon/>
            <div className="flex flex-column sm:flex-column md:flex-column xl:flex-row lg:flex-row justify-content-between lg:flex-wrap xl:flex-wrap w-12 xl:py-2 lg:py-2 px-2">
                <Text type={'heading'}>{company?.companyName}</Text>
                <Text type={'heading'}>Subscription Type : {userSub.isUserSub?userSub.userSubType:'none'}{ userSub.isUserSub? `(${userSub.plan})`:''}</Text>
            </div>
        </div>
      </div>

      <div className={`xl:flex lg:flex w-11 m-auto pb-8`}>
      <div  className={`w-12 xl:w-6 lg:w-6 `} >
      <form onSubmit={handleSubmit(onSubmit)} className="p-fluid w-12 xl:w-8 lg:w-8 xl:w-10 lg:w-10">
          <div className="field">
            <label
              htmlFor="businessMobno"
              className={classNames({ "p-error": errors.name })}
            >
              Business Mobile Number*
            </label>
            <Controller
              name="businessMobno"
              control={control}
              rules={{ required: "Please enter a Business Mobile Number" }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                  placeholder="Enter Business Mobile Number"
                  {...field}
                  disabled={!mode}
                />
              )}
            />
            {getFormErrorMessage("Business Mobile Number")}
          </div>
          <div className="field">
            <label
              htmlFor="personalMobno"
              className={classNames({ "p-error": errors.name })}
            >
              Personal Mobile Number*
            </label>
            <Controller
              name="personalMobno"
              control={control}
              rules={{ required: "Please enter a Personal Mobile Number" }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                  placeholder="Enter Personal Mobile Number"
                  {...field}
                  disabled={!mode}
                />
              )}
            />
            {getFormErrorMessage("Personal Mobile Number")}
          </div>
          <div className="field">
            <label
              htmlFor="gst"
              className={classNames({ "p-error": errors.name })}
            >
              GST No*
            </label>
            <Controller
              name="gst"
              control={control}
              rules={{ required: "Please enter a GST No" }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                  placeholder="Enter GST No"
                  {...field}
                  disabled={!mode}
                />
              )}
            />
            {getFormErrorMessage("GST No")}
          </div>
          <div className="field">
            <label
              htmlFor="pan"
              className={classNames({ "p-error": errors.name })}
            >
              PAN No*
            </label>
            <Controller
              name="pan"
              control={control}
              rules={{ required: "Please enter a PAN No" }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                  placeholder="Enter PAN No"
                  {...field}
                  disabled={!mode}
                />
              )}
            />
            {getFormErrorMessage("PAN No")}
          </div>
          <div className="field">
            <label
              htmlFor="billadd"
              className={classNames({ "p-error": errors.name })}
            >
              Billing Address*
            </label>
            <Controller
              name="billadd"
              control={control}
              rules={{ required: "Please enter a Billing Address" }}
              render={({ field, fieldState }) => (
                <InputTextarea 
                  id={field.name}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                  placeholder="Enter Billing Address"
                  {...field}
                  autoResize 
                  disabled={!mode}
                />
              )}
            />
            {getFormErrorMessage("Billing Address")}
          </div>
    
          <div>
            <CustomButton
              varient="filled w-4"
              type={mode ? "submit" : ""}
              onClick={handelmode}
              label={mode ? "Save" : "Edit"}
            />
          </div>
        </form>

        <div className="sales-card p-3 w-12 xl:w-8 lg:w-8 xl:w-10 lg:w-10 mt-3">
          <div className="my-2">Sales Contact Personal </div>
          <Text type={'heading'} >Goldwin Paul</Text>
          <div className="my-2">Mobile: <span className="font-semibold"> +91 94903 37682</span> </div>
          <div className="my-2">Email: <span className="font-semibold">goldwin.paul@deskala.in</span></div>

        </div>
   
      </div>
      <div className="w-12 xl:w-10 lg:w-10 lg:px-3 panel-right sm:flex sm:justify-content-center">
        <div className="w-full my-5" style={{ maxWidth: 256, maxHeight: 256}}>
            <QRCode
              id="generatedQrCode"
              size={256}
              style={{ height: "100%", display:"block", margin: "auto" }}
              value={`https://wa.me/${company?.phone}`}
            />
            <CustomButton
                varient="filled w-12 mt-5 m-auto"
                type={"submit"}
                onClick={handelQR}
                label={'Download Qr Code'}
              />
        </div>
      </div>
      
      </div>
    </div>
    </> );
}

export default UserProfile;